import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Form, Button, Modal } from "semantic-ui-react";
import InventorySearch from "../../utils/searches/InventorySearch";
import FormErrorMessage from "../../utils/FormErrorMessage";
import { updatePricingModelInStore, updateOrCreatePricing } from "../../../actions/relation";
import Dls from "../../../lib";

class InventoryPricingModalForm extends Component {
    constructor() {
        super();
        this.state = {
            errors: [],
            loading: false
        };
    }

    onInventorySearchSelected = (inventoryItem) => {
        const {id, sku, name, selling, cost} = inventoryItem;
        const {type} = this.props;
        this.props.updatePricingModelInStore('sku', sku, false);
        this.props.updatePricingModelInStore('name', name, false);
        this.props.updatePricingModelInStore('cost', cost, false);
        this.props.updatePricingModelInStore('selling', selling, false);
        this.props.updatePricingModelInStore('inventory_id', id, true);
        this.props.updatePricingModelInStore('special_sku', sku, true);
        this.props.updatePricingModelInStore('special_name', name, true);
        if (type === 'customer') {
            this.props.updatePricingModelInStore('special_price', selling, true);
        } else {
            this.props.updatePricingModelInStore('special_price', cost, true);
        }
    }

    onFormSubmit = () => {
        const errors = this.validateInput();
        if (_.isEmpty(errors)) {
            this.setState({
                loading: true
            });
            this.props
                .updateOrCreatePricing(this.props.jwt, this.props.model)
                .then(res => {
                    this.setState({
                        loading: false,
                        errors: []
                    })
                })
                .catch(err => {
                    const errors = Dls.apiErrorMessage(err);
                    this.setState({
                        loading: false,
                        errors: errors
                    });
                });
        } else {
            this.setState({
                errors: errors
            });
        }
    };

    validateInput = () => {
        const { pivot } = this.props.model;
        const errors = [];
        if (!pivot.relation_id) {
            errors.push("Relation is required");
        }
        if (!pivot.inventory_id) {
            errors.push("Please select an inventory item");
        }
        if (_.isNaN(parseFloat(pivot.special_price))) {
            errors.push("Price must be a number");
        }
        return errors;
    };
    
    render() {
        const {model, updatePricingModelInStore, isDirty, isOpen, type, exceptIds} = this.props
        return (
            <Modal
                open={isOpen}
                dimmer='blurring'
                closeOnEscape={true}
                closeOnDimmerClick={false}
                onClose={() => {this.props.onModalClose()}}
                size='tiny'
            >
                <Modal.Header>Manage Pricing</Modal.Header>
                <Modal.Content>
                    <Form size="mini">
                        {!_.isEmpty(this.state.errors) ? (
                            <FormErrorMessage errors={this.state.errors} />
                        ) : null}
                            {model.id ? <div>
                                <h3>Original SKU: {model.sku} <br />
                                    <small>{model.name}</small>
                                </h3>
                            </div> : <div>
                                <InventorySearch 
                                    jwt={this.props.jwt}
                                    onSelected={(item) => {this.onInventorySearchSelected(item)}}
                                    exceptIds={exceptIds}
                                    requireInventoryPricing={false}
                                    relationId="0"
                                />
                            </div>}

                            <Form.Input 
                                fluid 
                                label={`${_.upperFirst(type)} SKU`}
                                name="special_sku"
                                value={model.pivot.special_sku ? model.pivot.special_sku : ""} 
                                onChange={(e) => { updatePricingModelInStore(e.target.name, e.target.value, true) }}
                            />
                            <Form.Input 
                                fluid 
                                label={`${_.upperFirst(type)} Product Name`}
                                name="special_name"
                                value={model.pivot.special_name ? model.pivot.special_name : ""} 
                                onChange={(e) => { updatePricingModelInStore(e.target.name, e.target.value, true) }}
                            />
                            <Form.Input 
                                fluid 
                                label={type === 'vendor' ? 'Purchase Cost' : 'Selling Price'}
                                name="special_price"
                                value={model.pivot.special_price ? model.pivot.special_price : ""} 
                                onChange={(e) => { updatePricingModelInStore(e.target.name, e.target.value, true) }}
                            />
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <div className="row">
                        <div className="col-md-12">
                        <Button onClick={() => {this.props.onModalClose()}} color="red" floated='left' size='mini'>
                            Close
                        </Button>
                        <Button
                            size='mini'
                            color="teal"
                            onClick={this.onFormSubmit}
                            loading={this.state.loading}
                            disabled={!isDirty}
                            floated='right'
                        >
                            Save
                        </Button>
                        </div>
                    </div>
                </Modal.Actions>
            </Modal>
        );
    }
}

InventoryPricingModalForm.propTypes = {
    updateOrCreatePricing: PropTypes.func.isRequired,
    updatePricingModelInStore: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
    isDirty: PropTypes.bool.isRequired,
    jwt: PropTypes.string.isRequired,
    //Below 3 need to be passed from parent
    isOpen: PropTypes.bool.isRequired,
    onModalClose: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    exceptIds: PropTypes.array.isRequired
};

function mapStateToProps(state) {
    return {
        model: state.pricing.model,
        isDirty: state.pricing.dirty,
        jwt: state.auth.jwt
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            updatePricingModelInStore, updateOrCreatePricing
        },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InventoryPricingModalForm);



// WEBPACK FOOTER //
// ./src/components/forms/relations/InventoryPricingModal.js